import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Produtos1 from '../imagens/CadProdutos/Produtos1.png';
import Produtos2 from '../imagens/CadProdutos/Produtos2.png';
import Produtos3 from '../imagens/CadProdutos/Produtos3.png';
import Produtos4 from '../imagens/CadProdutos/Produtos4.png';
import Produtos5 from '../imagens/CadProdutos/Produtos5.png';
import Produtos6 from '../imagens/CadProdutos/Produtos6.png';
import Produtos7 from '../imagens/CadProdutos/Produtos7.png';

export default class CadProdutos extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o Cadastro de Produtos"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o Cadastro de Produtos:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Produtos1} alt="Produtos 1"/>
                        </div>

                        <div className="gray_bar"></div>  

                        <div className="image-wrapper">
                            <img src={Produtos2} alt="Produtos 2"/>
                        </div>                                            

                        <h3>No cadastro de Produtos nós temos:</h3>
                        <ol>
                            <li>Cadastrar um novo produto.</li>
                            <li>Tabela de produtos cadastrados.</li>
                            <li>Botão auxiliar para ativar/desativar um produto.</li>
                            <li>Botões auxiliares para excluir/alterar um produto.</li>
                            <li>Paginação da tabela de produtos.</li>
                        </ol>

                        <div className="gray_bar"></div> 

                        <h3>Como cadastrar um novo Produto</h3>

                        <p>
                            Para cadastrar um novo Produto o gestor deve primeiro clicar no botão "Adicionar" no cadastro de Produtos.
                        </p>

                        <div className="image-wrapper">
                            <img src={Produtos3} alt="Produtos 3"/>
                        </div>  

                        <p>
                            Na tela de cadastro que será aberta o gestor deve preencher as informações do Produto e depois para salvar, basta clicar no botão "Salvar".
                        </p>

                        <p>
                            A maioria das informações do produto são simples, mas algumas delas exigem um pouco mais de atenção. Dentre elas temos os campos de Código Origem, 
                            NCM, mostra no Catálogo, controla Estoque, Estoque em Grade e adicionar imagem. 
                        </p>

                        <div className="image-wrapper">
                            <img src={Produtos4} alt="Produtos 4"/>
                        </div>       

                        <p>
                            O campo de código é o sequencial que o próprio sistema cria, e o código orig. serve para que o gestor possa colocar um código informativo
                            caso o produto tenha um código do fornecedor. 
                        </p>                   
                        <p>
                            O campo de NCM(Nomenclatura Comum do Mercosul) é um código que cada grupo de produtos possui que deve ser informado obrigatorimente caso o 
                            gestor for emitir notas com esse produto. 
                        </p>
                        <p>
                            O check de mostrar no catálogo serve para que o produto seja exibido no catálogo do aplicativo de celular. 
                        </p>
                        <p>
                            O check de Controla Estoque serve para informar se o sistema irá gerenciar a quantidade estoque desse item ou não.
                        </p>
                        <p>
                            Adicionar imagem serve para que o gestor possa adicionar uma imagem ilustrativa do item caso desejar. A imagem é especialmente
                            útil para itens que estão sendo exibidos no catálogo ou na lista no aplicativo. 
                        </p>
                        <p>
                            O check de Estoque em Grade serve para quando um item pode ter diferentes verções do mesmo item, como por exemplo calças jeans tendo 
                            vários tamanhos e cores. 
                        </p>
                        <div className="image-wrapper">
                            <img src={Produtos5} alt="Produtos 5"/>
                        </div>    

                        <p>
                            Na grade os produtos podem possuir cor e tamanho. Ambos esses campos podem ser cadastrados no sistema.
                        </p>     
                        <div className="image-wrapper">
                            <img src={Produtos6} alt="Produtos 6"/>
                        </div>    

                        <div className="gray_bar"></div> 

                        <h3>Como alterar/excluir um item</h3>

                        <p>
                            Para desativar um item o gestor pode usar o botão da opção auxiliar na tabela de produtos que está escrito situação. Para excluir ou alterar
                            um item o gestor pode usar os outros dois botões do lápis e da lixeira. Lembrando que um item não pode ser excluído caso ja tenha sido movimentado.
                        </p>                                                             
                        <div className="image-wrapper">
                            <img src={Produtos7} alt="Produtos 7"/>
                        </div>  
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/CadProdutos.js